import { Col, DatePicker, Form, Input, Row } from 'antd'
import CustomSpin from '../../../elements/CustomSpin'
import DeliveryDetails from '../../../elements/DeliveryDetails'
import FormSectionTitle from '../../../elements/FormSectionTitle'
import QADetails from '../../../elements/QADetails'
import RegisteredPartnerDetails from '../../../elements/RegisteredPartnerDetails'
import { get } from 'lodash'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../../../modules/FormItems'
import { dateVal, strVal } from '../../../modules/Utils'
import React from 'react'


function MROForm(props) {
  const { mrn, fetching } = props
  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields } = props.form

  return (
    <CustomSpin spinning={fetching}>
      <Form>
        <FormSectionTitle title={'Material Release Note Details'} />

        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Date">
              {getFieldDecorator('date', {
                initialValue: dateVal(mrn, 'date'),
              })(<DatePicker style={{ width: '100%' }} placeholder="Date" />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item {...fullWidthFormItemLayout} label="Title">
              {getFieldDecorator('title', {
                initialValue: strVal(mrn, 'title'),
                rules: rules.input,
              })(<Input placeholder="Title" />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          {get(mrn, 'qaRequirements.isReleaseInspection') && (
            <QADetails
              doc={mrn}
              {...{
                getFieldDecorator,
                getFieldValue,
                setFieldsValue,
              }}
            />
          )}
        </Row>
        <Row>
          <RegisteredPartnerDetails
            doc={mrn}
            {...{
              getFieldDecorator,
              getFieldValue,
              setFieldsValue,
              type: 'purchase',
            }}
          />
        </Row>
        <DeliveryDetails
          doc={mrn}
          {...{
            getFieldDecorator,
            getFieldValue,
            setFieldsValue,
            resetFields,
            type: 'Package',
            title: 'Delivery / Release Details',
          }}
        />
      </Form>
    </CustomSpin>
  )
}

MROForm.propTypes = {}
MROForm.defaultProps = {}

export default Form.create()((MROForm))
